"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPermissionSets = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _union = _interopRequireDefault(require("lodash/union"));

var _rest = require("../rest");

var fetchPermissionSets = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(permissionSetIds) {
    var permissionSets, userPermissionSets;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _rest.getPermissionSetsApi)();

          case 3:
            permissionSets = _context.sent;
            userPermissionSets = typeof permissionSetIds === 'string' ? [permissionSetIds] : permissionSetIds;
            return _context.abrupt("return", userPermissionSets.reduce(function (acc, setId) {
              var permissionSet = permissionSets.find(function (current) {
                return current.id === setId;
              });

              if (permissionSet) {
                acc = (0, _union.default)(acc, permissionSet.permissions);
              }

              return acc;
            }, []));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            // todo handle errors
            console.log(_context.t0);
            return _context.abrupt("return", []);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function fetchPermissionSets(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchPermissionSets = fetchPermissionSets;
//# sourceMappingURL=utils.js.map